import React from 'react';
import { activity_noActivities, activity_status_completed, activity_status_inProgress } from '@paraglide/messages';
/**
 * 활동 목록 컴포넌트
 */ var ActivityList = function(param) {
    var activities = param.activities, getActivityTypeIcon = param.getActivityTypeIcon, formatDate = param.formatDate, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    if (activities.length === 0) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "text-center py-10 text-gray-500 dark:text-gray-400"
        }, activity_noActivities());
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "space-y-4 ".concat(className)
    }, activities.map(function(activity) {
        return /*#__PURE__*/ React.createElement("div", {
            key: activity.id,
            className: "bg-white dark:bg-gray-800 rounded-lg shadow p-4 border-l-4 ".concat(activity.completed ? 'border-green-500 dark:border-green-600' : 'border-yellow-500 dark:border-yellow-600')
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-start"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "mr-3 mt-1"
        }, getActivityTypeIcon(activity.type)), /*#__PURE__*/ React.createElement("div", {
            className: "flex-1"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center justify-between"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "text-xs px-2 py-1 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300"
        }, activity.type), /*#__PURE__*/ React.createElement("span", {
            className: "ml-2 text-xs text-gray-500 dark:text-gray-400"
        }, activity.category)), /*#__PURE__*/ React.createElement("span", {
            className: "text-xs text-gray-500 dark:text-gray-400"
        }, formatDate(activity.date), " ", activity.time)), /*#__PURE__*/ React.createElement("h3", {
            className: "font-medium mt-1"
        }, activity.title), /*#__PURE__*/ React.createElement("p", {
            className: "text-sm text-gray-600 dark:text-gray-400 mt-1"
        }, activity.description), /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center justify-between mt-3 text-xs"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex items-center"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 px-2 py-1 rounded"
        }, activity.duration), /*#__PURE__*/ React.createElement("span", {
            className: "ml-2 bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 px-2 py-1 rounded"
        }, activity.points, "P")), /*#__PURE__*/ React.createElement("span", {
            className: "font-medium ".concat(activity.completed ? 'text-green-600 dark:text-green-400' : 'text-yellow-600 dark:text-yellow-400')
        }, activity.completed ? activity_status_completed() : activity_status_inProgress())))));
    }));
};
export default ActivityList;
